module.exports = __webpack_public_path__ + "static/media/logo3.52a1c73b.png";